var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { class: _vm.wrapperClass, attrs: { to: _vm.link } },
    [
      _vm.user.avatar
        ? _c("img", {
            key: _vm.user.id,
            class: _vm.avatarClass,
            attrs: {
              src: `/images/avatar/${_vm.user.id}`,
              alt: `Profile photo for ${_vm.user.name}`,
            },
          })
        : _c("span", {
            class: { ..._vm.avatarClass, initials: true },
            domProps: { textContent: _vm._s(_vm.initials) },
          }),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("h3", { class: { h2: !_vm.small && !_vm.tiny } }, [
          _vm._v(_vm._s(_vm.user.name)),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.user.member))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }